import { useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";
import UpiPayCard from "../components/UpiPayCard";

export default function PayUpi() {
  const [sp] = useSearchParams();
  const initialAmount = Number(sp.get("amount") || 199);
  const initialPurpose = sp.get("purpose") || "wallet_topup";
  const ref = sp.get("ref") || null;
  const [amount, setAmount] = useState(initialAmount);
  const purpose = initialPurpose;
  const presets = useMemo(() => [99, 199, 499, 999, 1999], []);

  return (
    <div className="min-h-[80vh] py-10 md:py-16 px-4">
      <div className="max-w-2xl mx-auto">
        <div className="text-center mb-8">
          <span className="label-eyebrow">Instant UPI pay</span>
          <h1 className="mt-3 font-display text-4xl md:text-5xl font-bold" style={{ color: "#00604A" }}>
            Pay <span className="italic" style={{ color: "#F45118" }}>HeylpMate</span> in 3 taps.
          </h1>
          <p className="mt-3 text-sm md:text-base" style={{ color: "#667085" }}>
            Scan the PhonePe QR or copy our UPI id. Share the screenshot on WhatsApp for instant confirmation.
          </p>
        </div>

        {/* Preset picker */}
        <div className="mb-4 rounded-2xl border p-4 bg-white" style={{ borderColor: "#E4E7E5" }} data-testid="pay-preset-row">
          <div className="text-xs font-bold uppercase tracking-widest mb-2" style={{ color: "#667085" }}>Choose amount</div>
          <div className="flex flex-wrap gap-2">
            {presets.map((p) => (
              <button key={p} onClick={() => setAmount(p)} data-testid={`pay-preset-${p}`}
                      className="px-4 py-2 rounded-full text-sm font-bold border-2 transition"
                      style={amount === p
                        ? { background: "#00604A", color: "#fff", borderColor: "#00604A" }
                        : { color: "#00604A", borderColor: "#00604A22" }}>
                ₹{p}
              </button>
            ))}
            <div className="inline-flex items-center gap-2 border-2 rounded-full px-3 py-1"
                 style={{ borderColor: "#E4E7E5" }}>
              <span className="text-sm" style={{ color: "#667085" }}>₹</span>
              <input data-testid="pay-custom-amount"
                     type="number" min={1}
                     value={amount}
                     onChange={(e) => setAmount(Math.max(1, Number(e.target.value) || 0))}
                     className="w-24 outline-none bg-transparent text-sm font-bold" style={{ color: "#00604A" }} />
            </div>
          </div>
        </div>

        <UpiPayCard amount={amount} purpose={purpose} referenceId={ref} />
      </div>
    </div>
  );
}
